import axios from "axios";
import { useEffect } from "react";
import { useState } from "react";
import RangeSection from "./Components/RangeSection";
import ChartStyle from "./Components/Results/ChartStyle";
import DetailTable from "./Components/Results/DetailTable";
import LineStyle from "./Components/Results/LineStyle";
import ResultHeader from "./Components/Results/ResultHeader";

const App = (() => {

	const [mounted, setMounted] = useState(false);

	const [results, setResults] = useState();

	const [refresh, setRefresh] = useState(true);

	const [selectedDate, setSelectedDate] = useState(new Date());

	const [empty, setEmpty] = useState(false);

	const ChangeDate = ((d) => {
		if (!mounted) return;
		setRefresh(false);
		FetchData(d);
	});


	useEffect(() => {
		FetchData(selectedDate);
	}, []);

	const FetchData = ((date) => {

		const url = new URL(window.location.href);

		const type = url.searchParams.get('game');

		let link = 'https://adminbet365.com/api/powerball3/statistics';
		if (type == 5) {
			link = 'https://adminbet365.com/api/powerball/statistics'
		}

		axios.post(link).then((res) => {
			if (res.data.length > 0) {
				setResults(res.data.reverse());
				setMounted(true);
				setRefresh(true);
				setEmpty(false);
			} else {
				setEmpty(true);
			}
		});
	});

	if (!mounted) return <Loader />;

	return (
		<div className="app-contaihner">
			<RangeSection change={ChangeDate} date={selectedDate} />
			{empty && <Empty />}
			{refresh && <>
				<ResultHeader result={results} />
				<LineStyle result={results} />
				<ChartStyle result={results} />
				<DetailTable result={results} />
			</>}
		</div>
	);
});


const Loader = (() => {
	return (
		<>
			<div className='app-container loader'>로딩중 ..</div>
		</>
	)
})


const Empty = (() => {
	return (
		<>
			<div className='app-container loader'>데이터를 찾을수 없습니다.</div>
		</>
	)
});


export default App;
